var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.952,
    height: 13.948,
    viewBox: "0 0 13.952 13.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-2136038",
    transform: "translate(-127.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245769",
    "data-name": "Path 245769",
    d: "M250.423,311.18h1.692a.437.437,0,0,0,.3-.123l8.458-8.458a.421.421,0,0,0,0-.6l-1.692-1.692a.421.421,0,0,0-.6,0l-8.458,8.458a.406.406,0,0,0-.127.3v1.692A.424.424,0,0,0,250.423,311.18Zm.423-1.941,8.035-8.035,1.1,1.1-8.035,8.035h-1.1Z",
    transform: "translate(-122.886 -297.231)",
    fill: "#038de3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245770",
    "data-name": "Path 245770",
    d: "M827.455,129.536a.422.422,0,0,0,.3.127.436.436,0,0,0,.3-.123l1.692-1.692a.421.421,0,0,0,0-.6l-1.692-1.692a.421.421,0,0,0-.6,0l-1.679,1.679a.425.425,0,0,0,0,.6Zm.3-3.087,1.1,1.1-1.1,1.091-1.087-1.1Z",
    transform: "translate(-688.804 -125.438)",
    fill: "#038de3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.c876eb4101ab6a950b9cee86db4cfdc5.svg";
export { ForwardRef as ReactComponent };